import useGetGeneralSettings from "@src/providers/useGetGeneralSettings";

export const isFeatureEnabled = (featureName: string, pov?: string, permissions?: string) => {
    const generalSettings = useGetGeneralSettings();

    let setting;
    switch(featureName) {
        case "AIIntegration":
            setting = generalSettings.find(setting => setting.name === 'AIIntegration');
            return setting?.config?.show_ai_integration === true;
        case "SubmissionBuilder":
            setting = generalSettings.find(setting => setting.name === 'SubmissionBuilder');
            return setting?.config?.show_submission_builder === true;
        case "Charges":
            setting = generalSettings.find(setting => setting.name === 'ChargesSettings');
            const chargesSettings = setting?.config;
            if(chargesSettings?.ENABLED != true)
                return false

            if(chargesSettings.hide_for_serviceowners == true && pov === "SERVICE_OWNER")
                return false

            if(chargesSettings.hide_for_consumers == true && pov === "CONSUMER")
                return false

            if(chargesSettings.only_admins_can_see == true && permissions !== "ADMIN")
                return false

            return true
        default:
            return true;
    }
} 